import React from 'react';

function FipCard({
  application: {
    serialNumber,
    equipmentType,
    submittedDate,
    incentiveAmount,
    permalink,
    status
  }
}) {
  const formatEquipmentType = (type) => {
    type = type.replace(/([A-Z])/g, ' $1').trim();
    return type.charAt(0).toUpperCase() + type.slice(1);
  };

  const statusClass =
    !status || status === 'In Progress' ? 'active' : status.toLowerCase();

  return (
    <div className="grid__col-xs-12 grid__col-xl-6">
      <div className={`fip card-project card-project--${statusClass}`}>
        <div className="card-project__address">
          <div className="card-project__street">
            {formatEquipmentType(equipmentType)} - {serialNumber}
          </div>
        </div>
        <div className="card-project__status">
          <span className="card-project__status-indicator">{status}</span>
        </div>
        <div className="card-project__completion-date">
          <div>
            Submitted Date:{' '}
            <span>
              {submittedDate
                ? new Date(submittedDate).toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric'
                  })
                : ''}
            </span>
          </div>
        </div>
        <div className="card-project_qualify-for">
          <div>
            Qualifying for{' '}
            <span className="card-project_qualify-amount">
              {parseInt(incentiveAmount) > 0
                ? `$${parseInt(incentiveAmount).toLocaleString()}`
                : 'TBD'}
            </span>
          </div>
        </div>
        <div className="card-project__view-details">
          <a
            href={permalink}
            className="btn btn--link btn--sm btn--has-arrow module-hover-root"
          >
            <span className="btn__content">
              <span className="btn__text">View/Edit Details</span>
              <span className="btn__arrow arrow"></span>
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default FipCard;
